/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Control } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './toparticles_styles';



/* ========== ~~~~~~~~~~ COMMUNITY TOP ARTICLES ~~~~~~~~~~ ========== */
const TopArticles = props => {
  const { topArticlesInitialLoadLimit, onChange } = props;
  const topArticlesOptions = [2, 6, 10, 14, 18, 20];

  return (
    <div className={`toparticles ${props.classes.toparticles} section`}>
      <div className={`sectioncontent`}>
        { topArticlesOptions.map((value) =>
          <Control 
            text={value.toString()} 
            value={value} 
            handleSelect={() => onChange(value)} 
            variant={'secondary'} 
            selected={topArticlesInitialLoadLimit === value}  
          />
        )}
      </div>
    </div>
  )
}

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(TopArticles);